import storage from '@/utils/localstorage'

export default {
  namespaced: true,
  state: {
    accessToken: storage.get('ACCESS_TOKEN'),
    user: storage.get('USER'),
    permissions: storage.get('PERMISSIONS')
  },
  mutations: {
    setAccessToken(state, val) {
      storage.set('ACCESS_TOKEN', val)
      state.accessToken = val
    },
    setUser(state, val) {
      storage.set('USER', val)
      state.user = val
    },
    setPermissions(state, val) {
      storage.set('PERMISSIONS', val)
      state.permissions = val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js